<template>
	<div class="scanner-list-item row" :class="itemClasses">
		<div class="col-11">
			<div class="row align-items-center">
				<div class="col-10">
					Nr: {{bottleNo}}
					<div v-if="highlights && showWarning">
						{{$t('fällig am:')}} {{new Date(dueDate).toLocaleDateString()}}
					</div>
					<div v-if="highlights && !dueDate" class="small">
						{{$t('fälligkeit konnte nicht geprüft werden!')}}
					</div>
				</div>
				<div class="col-2 text-center">
					<slot v-bind:bottleNo="bottleNo"/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "ScannerListItem",
		props: {
			bottleNo: String,
			dueDate: String,
			warnBeforeDue: {
				type: String,
				default: "7 days"
			},
			highlights: {
				type: Boolean,
				default: true
			}

		},
		computed: {
			showWarning() {
				if (!this.dueDate) {
					return false
				}
				let x = this.warnBeforeDue.split(' ');
				return this.$moment().add(parseInt(x[0]), x[1]).unix() >= this.$moment(this.dueDate).unix()
			},
			itemClasses() {
				if (!this.highlights) {
					return {}
				}
				return {
					'bg-warning': !this.showWarning && !this.dueDate,
					'bg-danger': this.showWarning
				}
			}
		}
	}
</script>

<style scoped>

</style>
